<ng-container *ngIf="dataServ.rData">
  <ion-item class="ion-hide">
    <ion-label>{{'Language'}}</ion-label>
    <ion-select [(ngModel)]="userLang" (ionChange)="changeLang()" #languageSelect>
      <ng-container *ngFor="let lang of langs">
        <ion-select-option [value]="lang.code" *ngIf="dataServ.rData.languages.includes(lang.code)">{{lang.nativeName}}
        </ion-select-option>
      </ng-container>
    </ion-select>
  </ion-item>
  <ion-button (click)="languageSelect.open()" expand="block" fill="outline">
    <ion-icon slot="start" name="flag-outline"></ion-icon>
    {{'Language' | translate}} 
  </ion-button>
</ng-container>